import React from "react";
import { Link, NavLink } from "react-router-dom";

const Logo = () => (
  <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
    <div className="relative">
      <div className="w-8 h-8 rounded-lg" style={{ background: "#1E1924" }} />
      <div
        className="absolute inset-0 rounded-lg flex items-center justify-center text-white font-extrabold text-[15px] tracking-hero"
        style={{ background: "#7228C8", transform: "translate(4px, -4px)" }}
      >
        W
      </div>
    </div>
    <span className="font-extrabold text-[19px] tracking-hero ml-2" style={{ color: "#1E1924" }}>
      We<span style={{ color: "#7228C8" }}>·</span>Spik
    </span>
  </Link>
);

export const Nav = () => {
  const linkClass = ({ isActive }) =>
    `text-[14px] font-medium transition-colors ${isActive ? "text-[#1E1924]" : "text-[#70667A] hover:text-[#1E1924]"}`;

  return (
    <header
      className="sticky top-0 z-40 border-b"
      style={{ background: "rgba(250,249,251,0.85)", backdropFilter: "blur(12px)", borderColor: "#DEDAE2" }}
    >
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-10 h-[68px] flex items-center justify-between gap-3">
        <div className="flex items-center gap-10">
          <Logo />
          <nav className="hidden md:flex items-center gap-8">
            <NavLink to="/tutores" className={linkClass} data-testid="nav-tutores">
              Tutores
            </NavLink>
            <NavLink to="/dashboard" className={linkClass} data-testid="nav-dashboard">
              Mi progreso
            </NavLink>
          </nav>
        </div>
        <div className="flex items-center gap-3">
          <Link
            to="/reservar"
            className="wk-btn wk-btn-primary h-11 px-3 sm:px-5 whitespace-nowrap"
            data-testid="nav-booking"
          >
            <span className="sm:hidden">Reservar · $22</span>
            <span className="hidden sm:inline">Reservar mi primera sesión · $22</span>
          </Link>
        </div>
      </div>
    </header>
  );
};
